module.exports = __webpack_public_path__ + "img/s2-4.f6c16ce0.png";